/**
 * The plan page's tab vocabulary — slug and label together, because the slug
 * is a URL someone can paste and the label is what they read.
 *
 * Named for what each answers rather than how much of it there is. "Summary"
 * and "Details" described volume, which told a strategist nothing about which
 * one to open; "Explore" described an activity rather than a question.
 *
 * Deliberately a module with no imports. The `/scenarios/$tab` route validates
 * its segment at `beforeLoad`, and route definitions ship in the startup
 * bundle — importing this from `plan-view` pulled recharts into first paint.
 */
export type PlanTab = 'diagnosis' | 'what-if' | 'pacing' | 'ledger'

export const PLAN_TABS: PlanTab[] = ['diagnosis', 'what-if', 'pacing', 'ledger']

export const TAB_LABELS: Record<PlanTab, string> = {
  diagnosis: 'Diagnosis',
  'what-if': 'What if',
  pacing: 'Pacing',
  ledger: 'Ledger',
}

export function isPlanTab(v: unknown): v is PlanTab {
  return typeof v === 'string' && (PLAN_TABS as string[]).includes(v)
}
